/* ==========================================================================
   Kopstorm CRO Suite - kopstorm-w11.js
   Anavrin product page V6, flag w87

   Behaviours, all inert until the flag class is on <html>:
     1. reveal on scroll, with the blur that resolves
     2. lit state toggle, moves the gallery to a slide that already exists
     3. kit picker: this kit, or this kit plus a second one the shopper chooses
     4. total mirrored into the theme's own add to cart button
     5. submit interception, so the second kit and any ticked accessory are
        added in the same request as the shopper's own add to cart
     6. tabs, read more, accordions, steps
     7. pay later modal, kit chooser dialog
     8. video thumbs open the theme's own gallery item

   Nothing caches a node list across a variant change: the theme rerenders
   product info server side, so every handler is delegated from document.
   ========================================================================== */
(function () {
  'use strict';

  var FLAG = 'kop-w87';
  var EDIT = 'kop-w11editor';

  function live() {
    var c = document.documentElement.classList;
    return c.contains(FLAG) || c.contains(EDIT);
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* ---------------------------------------------------------- money format
     Never format from window.Shopify.money_format: that is the SHOP's format,
     not the presentment currency of the market being viewed, so on a Belgian
     shop serving the US market it prints a euro card beside a dollar button.
     Instead parse the sample the money FILTER rendered in the head, which is
     always the format of the market currently being served. The sample is
     1234500 cents, so the digit run is 12 345 00 in that currency's own
     grouping and a currency with no decimals still exposes its thousands mark.
     Shared with the W87 additions further down through window.KopstormW11.  */
  var moneyShape = null;

  function readMoneyShape() {
    var sample = (window.KopstormW11 && window.KopstormW11.moneySample) || '';
    var digits = sample.match(/[\d\s.,'\u00a0\u202f]*\d/);
    if (!digits) return { prefix: '$', suffix: '', thousands: ',', decimal: '.', places: 2 };

    var body = digits[0].replace(/^[\s\u00a0\u202f]+/, '');
    var start = sample.indexOf(body);
    var count = (body.match(/\d/g) || []).length;
    var marks = body.replace(/\d/g, '').split('');
    var places = count >= 7 ? 2 : 0;

    var thousands = '';
    var decimal = '.';
    if (places === 2) {
      if (marks.length >= 2) {
        thousands = marks[0];
        decimal = marks[marks.length - 1];
      } else if (marks.length === 1) {
        decimal = marks[0];
      }
    } else if (marks.length >= 1) {
      thousands = marks[0];
    }

    return {
      prefix: sample.slice(0, start),
      suffix: sample.slice(start + body.length),
      thousands: thousands,
      decimal: decimal,
      places: places
    };
  }

  function money(cents) {
    if (!moneyShape) moneyShape = readMoneyShape();
    var shape = moneyShape;
    var value = Math.round(cents) / 100;
    var fixed = shape.places === 2 ? value.toFixed(2) : Math.round(value).toFixed(0);
    var parts = fixed.split('.');
    var whole = shape.thousands
      ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, shape.thousands)
      : parts[0];
    var body = shape.places === 2 ? whole + shape.decimal + parts[1] : whole;

    return shape.prefix + body + shape.suffix;
  }

  window.KopstormW11 = window.KopstormW11 || {};
  window.KopstormW11.money = money;

  /* -------------------------------------------------------------- reveal */
  var revealObserver = null;

  function observeReveals(root) {
    if (!live()) return;
    var nodes = (root || document).querySelectorAll('[data-kop11-reveal]:not(.is-in)');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }
    for (var n = 0; n < nodes.length; n++) revealObserver.observe(nodes[n]);
  }

  /* ------------------------------------------------------------- gallery */
  function galleryFor(scope) {
    var wrap = scope ? closest(scope, '.shopify-section') : document;
    return (wrap || document).querySelector('slider-element[id^="SliderGallery"], .product__media-list, media-gallery');
  }

  function showSlide(index, from) {
    var gallery = galleryFor(from);
    if (!gallery) return;

    if (typeof gallery.select === 'function') {
      try {
        gallery.select(index);
        return;
      } catch (e) {
        /* fall through */
      }
    }
    var items = gallery.querySelectorAll('.product__media, .slider__item');
    var target = items[index];
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function openMedia(mediaId, from) {
    var gallery = galleryFor(from);
    if (!gallery) return;
    var item = gallery.querySelector('[data-media-id$="' + mediaId + '"], [data-media-id="' + mediaId + '"]');
    if (!item) return;

    if (item.scrollIntoView) item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var trigger = item.querySelector('button, [data-media-play], video-media');
    if (trigger && trigger.click) trigger.click();
  }

  /* ---------------------------------------------------------------- modal */
  // Modals are portaled to document.body on first open. Anywhere inside the
  // product column an ancestor can carry a filter, transform or will-change
  // from the reveal system, and any of those makes position:fixed resolve
  // against that ancestor instead of the viewport, which is exactly the
  // "overlay does not paint" bug. On body there is no such ancestor.
  function findModal(name) {
    return document.querySelector('[data-kop11-modal="' + name + '"]');
  }

  var modalReturnFocus = null;

  function focusables(root) {
    return root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  }

  function openModal(name, opener) {
    var modal = findModal(name);
    if (!modal) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modalReturnFocus = opener || document.activeElement;

    // locking the scroll removes the scrollbar, which shifts the page under
    // the scrim; pad the same width back on so nothing moves
    var gap = window.innerWidth - document.documentElement.clientWidth;
    if (gap > 0) document.documentElement.style.paddingInlineEnd = gap + 'px';
    document.documentElement.style.overflow = 'hidden';

    modal.removeAttribute('hidden');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var panel = modal.querySelector('.kop11-modal__panel');
      if (!panel) return;
      var target = panel.querySelector('[data-kop11-opt].is-chosen') || focusables(panel)[0];
      if (target && target.focus) target.focus();
    });
  }

  function closeModals() {
    var open = document.querySelectorAll('[data-kop11-modal].is-open');
    if (!open.length) return;
    for (var i = 0; i < open.length; i++) {
      (function (modal) {
        modal.classList.remove('is-open');
        setTimeout(function () {
          if (!modal.classList.contains('is-open')) modal.setAttribute('hidden', '');
        }, 220);
      })(open[i]);
    }
    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingInlineEnd = '';
    if (modalReturnFocus && modalReturnFocus.focus) modalReturnFocus.focus();
    modalReturnFocus = null;
  }

  /* ---------------------------------------------------------- kit picker */
  function scoped(sel, scope) {
    return document.querySelector(sel + '[data-kop11-scope="' + scope + '"]');
  }

  function optionsFor(scope) {
    var modal = scoped('[data-kop11-modal="kits"]', scope);
    return modal ? modal.querySelector('[data-kop11-options]') : null;
  }

  // the dialog footer names the current pick, so the choice is readable
  // before the dialog closes rather than only in the card behind it
  function syncPickedName(scope) {
    var modal = scoped('[data-kop11-modal="kits"]', scope);
    if (!modal) return;
    var out = modal.querySelector('[data-kop11-picked-name]');
    if (!out) return;
    var chosen = modal.querySelector('.kop11-opt.is-chosen');
    out.textContent = chosen ? (chosen.getAttribute('data-title') || '') : '';
  }

  /* ---------------------------------------------------------- kit picker */
  function scoped(sel, scope) {
    return document.querySelector(sel + '[data-kop11-scope="' + scope + '"]');
  }

  function optionsFor(scope) {
    var modal = scoped('[data-kop11-modal="kits"]', scope);
    return modal ? modal.querySelector('[data-kop11-options]') : null;
  }

  // the dialog footer names the current pick, so the choice is readable
  // before the dialog closes rather than only in the card behind it
  function syncPickedName(scope) {
    var modal = scoped('[data-kop11-modal="kits"]', scope);
    if (!modal) return;
    var out = modal.querySelector('[data-kop11-picked-name]');
    if (!out) return;
    var chosen = modal.querySelector('.kop11-opt.is-chosen');
    out.textContent = chosen ? (chosen.getAttribute('data-title') || '') : '';
  }

  function state(scope) {
    var kits = scoped('[data-kop11-kits]', scope);
    var selectedKit = kits ? kits.querySelector('.kop11-kit.is-selected') : null;
    var options = optionsFor(scope);
    var chosen = options ? options.querySelector('.kop11-opt.is-chosen') : null;
    return {
      kits: kits,
      two: selectedKit ? selectedKit.getAttribute('data-kit') === '2' : false,
      option: chosen
    };
  }

  function themeButton(scope) {
    var form = scope ? document.getElementById(scope) : null;
    var root = form ? form.closest('.product__info, product-info, .shopify-section') : null;
    return (root || document).querySelector('.product-form__submit');
  }

  function syncTotal(scope) {
    var s = state(scope);
    var kitsEl = s.kits;
    if (!kitsEl) return;


    var base = parseInt(kitsEl.getAttribute('data-base-price'), 10) || 0;
    var baseCompare = parseInt(kitsEl.getAttribute('data-base-compare'), 10) || 0;

    var total = base;
    var compare = baseCompare > base ? baseCompare : 0;

    if (s.two && s.option) {
      total += parseInt(s.option.getAttribute('data-price'), 10) || 0;
      compare = (baseCompare > base ? baseCompare : base) + (parseInt(s.option.getAttribute('data-compare'), 10) || 0);
    }

    // pieces render as separate wrappers, so addons are matched across all
    // buyarea instances that share this scope
    var addons = document.querySelectorAll('[data-kop11-buyarea][data-kop11-scope="' + scope + '"] [data-kop11-addon][aria-pressed="true"]');
    for (var i = 0; i < addons.length; i++) {
      var price = parseInt(addons[i].getAttribute('data-price'), 10) || 0;
      total += price;
      if (compare) compare += price;
    }

    // second row price, its struck compare and the saving, all per chosen kit
    var rowTotal = base + (s.option ? parseInt(s.option.getAttribute('data-price'), 10) || 0 : 0);
    var rowCompare =
      (baseCompare > base ? baseCompare : base) +
      (s.option ? parseInt(s.option.getAttribute('data-compare'), 10) || 0 : 0);

    var rowPrice = kitsEl.querySelector('[data-kop11-kit2-price]');
    if (rowPrice) rowPrice.textContent = money(rowTotal);

    var rowWas = kitsEl.querySelector('[data-kop11-kit2-was]');
    if (rowWas) {
      if (rowCompare > rowTotal) {
        rowWas.textContent = money(rowCompare);
        rowWas.removeAttribute('hidden');
      } else {
        rowWas.setAttribute('hidden', '');
      }
    }

    var rowSave = kitsEl.querySelector('[data-kop11-kit2-save]');
    if (rowSave) {
      if (rowCompare > rowTotal) {
        var prefix = kitsEl.getAttribute('data-save-prefix') || 'Save';
        rowSave.textContent = prefix + ' ' + money(rowCompare - rowTotal);
        rowSave.removeAttribute('hidden');
      } else {
        rowSave.setAttribute('hidden', '');
      }
    }
    var rowLine = kitsEl.querySelector('[data-kop11-second-line]');
    if (rowLine && s.option) {
      var template = rowLine.getAttribute('data-template') || rowLine.textContent;
      if (!rowLine.getAttribute('data-template')) rowLine.setAttribute('data-template', template);
      rowLine.textContent = rowLine
        .getAttribute('data-template')
        .replace(/\[kit\]/g, s.option.getAttribute('data-title'))
        .replace(/\[price\]/g, money(parseInt(s.option.getAttribute('data-price'), 10) || 0));
    }

    // mirror into the theme button
    var button = themeButton(scope);
    if (!button) return;
    var text = button.querySelector('.btn-text') || button;
    var holder = text.querySelector('.kop11-btn-price');
    if (!holder) {
      holder = document.createElement('span');
      holder.className = 'kop11-btn-price';
      holder.innerHTML = '<span class="kop11-btn-price__now"></span><span class="kop11-btn-price__was"></span>';
      text.appendChild(holder);
    }
    var now = holder.querySelector('.kop11-btn-price__now');
    var was = holder.querySelector('.kop11-btn-price__was');
    var nextNow = money(total);
    if (now.textContent !== nextNow) {
      now.textContent = nextNow;
      holder.classList.remove('is-changed');
      void holder.offsetWidth;
      holder.classList.add('is-changed');
    }
    was.textContent = compare > total ? money(compare) : '';
  }

  function selectKit(kit) {
    var kitsEl = closest(kit, '[data-kop11-kits]');
    if (!kitsEl) return;
    var scope = kitsEl.getAttribute('data-kop11-scope');
    var kits = kitsEl.querySelectorAll('[data-kop11-kit]');
    for (var i = 0; i < kits.length; i++) {
      var on = kits[i] === kit;
      kits[i].classList.toggle('is-selected', on);
      var btn = kits[i].querySelector('[data-kop11-kitbtn]');
      if (btn) btn.setAttribute('aria-checked', on ? 'true' : 'false');
    }

    // choosing the set with no second kit picked yet opens the chooser
    if (kit.getAttribute('data-kit') === '2' && !state(scope).option) {
      openModal('kits');
    }
    syncTotal(scope);
  }

  /* --------------------------------------------------------- add to cart */
  function extraItems(scope) {
    var items = [];
    var s = state(scope);
    if (s.two && s.option) {
      items.push({
        id: Number(s.option.getAttribute('data-variant')),
        quantity: 1,
        properties: { _kop11: 'w87-set' }
      });
    }
    var addons = document.querySelectorAll('[data-kop11-buyarea][data-kop11-scope="' + scope + '"] [data-kop11-addon][aria-pressed="true"]');
    for (var i = 0; i < addons.length; i++) {
      items.push({
        id: Number(addons[i].getAttribute('data-variant')),
        quantity: 1,
        properties: { _kop11: 'w87-addon' }
      });
    }
    return items;
  }

  function addExtras(scope) {
    var items = extraItems(scope);
    if (!items.length) return Promise.resolve();

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .catch(function () { /* the shopper's own line is already in the cart */ });
  }

  // The theme's product-form binds its listener on the element in its
  // constructor, so document capture is the only way to run first.
  document.addEventListener(
    'submit',
    function (event) {
      if (!live()) return;
      var form = event.target;
      if (!form || !form.getAttribute) return;
      if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') === -1) return;

      var id = form.getAttribute('id');
      if (!id) return;
      if (!extraItems(id).length) return;

      addExtras(id).then(function () {
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', { bubbles: true, detail: { source: 'kopstorm-w11' } })
        );
      });
    },
    true
  );

  /* -------------------------------------------------------------- events */
  document.addEventListener('click', function (event) {
    if (!live()) return;
    var target = event.target;

    // dialog openers first: the change control sits beside the kit row radio,
    // so this branch has to win over the row selection branch below
    var opener = closest(target, '[data-kop11-modal-open]');
    if (opener) {
      event.preventDefault();
      openModal(opener.getAttribute('data-kop11-modal-open'), opener);
      return;
    }

    var kitBtn = closest(target, '[data-kop11-kitbtn]');
    if (kitBtn) {
      selectKit(closest(kitBtn, '[data-kop11-kit]'));
      return;
    }

    var opt = closest(target, '[data-kop11-opt]');
    if (opt) {
      var wrap = closest(opt, '[data-kop11-options]');
      var all = wrap.querySelectorAll('[data-kop11-opt]');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.toggle('is-chosen', all[i] === opt);
        all[i].setAttribute('aria-pressed', all[i] === opt ? 'true' : 'false');
      }

      var modal = closest(opt, '[data-kop11-modal]');
      var scope = modal ? modal.getAttribute('data-kop11-scope') : null;
      var kitsEl = scope ? scoped('[data-kop11-kits]', scope) : null;
      if (!kitsEl) return;

      var thumb = kitsEl.querySelector('[data-kop11-second-thumb] img');
      var optImg = opt.querySelector('img');
      if (thumb && optImg) {
        thumb.src = optImg.currentSrc || optImg.src;
        thumb.removeAttribute('srcset');
      }

      // picking a kit selects the set, names it in the footer, and closes
      var setRow = kitsEl.querySelector('[data-kop11-kit][data-kit="2"]');
      if (setRow && !setRow.classList.contains('is-selected')) selectKit(setRow);
      else syncTotal(scope);
      syncPickedName(scope);
      if (modal) closeModals();
      return;
    }

    var addon = closest(target, '[data-kop11-addon]');
    if (addon) {
      addon.setAttribute('aria-pressed', addon.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      var addonArea = closest(addon, '[data-kop11-buyarea]');
      if (addonArea) syncTotal(addonArea.getAttribute('data-kop11-scope'));
      return;
    }

    var lit = closest(target, '[data-kop11-slide]');
    if (lit) {
      var group = closest(lit, '[data-kop11-lit]');
      if (group) {
        var buttons = group.querySelectorAll('.kop11-lit__btn');
        for (var b = 0; b < buttons.length; b++) {
          buttons[b].classList.remove('is-on');
          buttons[b].setAttribute('aria-pressed', 'false');
        }
        lit.classList.add('is-on');
        lit.setAttribute('aria-pressed', 'true');
      }
      showSlide(Number(lit.getAttribute('data-kop11-slide')), lit);
      return;
    }

    var mediaBtn = closest(target, '[data-kop11-open-media]');
    if (mediaBtn) {
      openMedia(mediaBtn.getAttribute('data-kop11-open-media'), mediaBtn);
      return;
    }

    var tab = closest(target, '[data-kop11-tab]');
    if (tab) {
      var tabs = closest(tab, '[data-kop11-tabs]');
      var index = tab.getAttribute('data-kop11-tab');
      var all2 = tabs.querySelectorAll('[data-kop11-tab]');
      for (var t = 0; t < all2.length; t++) {
        var on = all2[t] === tab;
        all2[t].classList.toggle('is-active', on);
        all2[t].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      var panels = tabs.querySelectorAll('[data-kop11-panel]');
      for (var p = 0; p < panels.length; p++) {
        if (panels[p].getAttribute('data-kop11-panel') === index) {
          panels[p].removeAttribute('hidden');
        } else {
          panels[p].setAttribute('hidden', '');
        }
      }
      return;
    }

    var more = closest(target, '[data-kop11-more]');
    if (more) {
      var clamp = closest(more, '[data-kop11-panel]').querySelector('[data-kop11-clamp]');
      var open = clamp.classList.toggle('is-open');
      more.classList.toggle('is-open', open);
      return;
    }

    var head = closest(target, '[data-kop11-acc-head]');
    if (head) {
      var expanded = head.getAttribute('aria-expanded') === 'true';
      head.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var body = head.nextElementSibling;
      if (body) {
        if (expanded) body.setAttribute('hidden', '');
        else body.removeAttribute('hidden');
      }
      return;
    }

    var stepHead = closest(target, '[data-kop11-step-head]');
    if (stepHead) {
      var wasOpen = stepHead.getAttribute('aria-expanded') === 'true';
      stepHead.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
      return;
    }

    if (closest(target, '[data-kop11-modal-close]')) {
      closeModals();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModals();
      return;
    }
    // focus stays inside the dialog while it is open
    if (event.key === 'Tab') {
      var openEl = document.querySelector('[data-kop11-modal].is-open');
      var panel = openEl ? openEl.querySelector('.kop11-modal__panel') : null;
      if (panel) {
        var f = focusables(panel);
        if (f.length) {
          var first = f[0];
          var last = f[f.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }
    }
    if (event.key === 'Enter' || event.key === ' ') {
      var kitBtn = closest(event.target, '[data-kop11-kitbtn]');
      if (kitBtn) {
        event.preventDefault();
        selectKit(closest(kitBtn, '[data-kop11-kit]'));
      }
    }
  });

  /* ------------------------------------------------------------- cut off */
  // Remaining time to the dispatch cut off, computed in the STORE timezone so
  // the promise is the same for every visitor. Falls back to the after-cutoff
  // line whenever the clock cannot be read.
  function storeNow(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz, weekday: 'short', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
      }).formatToParts(new Date());
      var get = function (type) {
        for (var i = 0; i < parts.length; i++) if (parts[i].type === type) return parts[i].value;
        return '';
      };
      var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return {
        d: days[get('weekday')] || 0,
        h: parseInt(get('hour'), 10) % 24,
        m: parseInt(get('minute'), 10),
        s: parseInt(get('second'), 10)
      };
    } catch (e) {
      return null;
    }
  }

  function tickCutoff() {
    var nodes = document.querySelectorAll('[data-kop11-cutoff]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var out = node.querySelector('[data-kop11-cutoff-text]');
      if (!out) continue;
      var now = storeNow(node.getAttribute('data-tz'));
      if (!now) {
        out.textContent = node.getAttribute('data-fallback');
        continue;
      }
      var hour = parseInt(node.getAttribute('data-hour'), 10) || 16;
      var weekend = node.getAttribute('data-weekend') === 'true';
      var allowed = function (day) { return weekend || (day >= 1 && day <= 5); };

      // seconds to the NEXT reachable cut off, skipping non dispatch days
      var todaySeconds = now.h * 3600 + now.m * 60 + now.s;
      var today = allowed(now.d) && todaySeconds < hour * 3600;
      var left;
      if (today) {
        left = hour * 3600 - todaySeconds;
      } else {
        var addDays = 1;
        while (!allowed((now.d + addDays) % 7) && addDays < 8) addDays += 1;
        left = addDays * 86400 - todaySeconds + hour * 3600;
      }

      var d = Math.floor(left / 86400);
      var h = Math.floor((left % 86400) / 3600);
      var m = Math.ceil((left % 3600) / 60);
      if (m === 60) { h += 1; m = 0; }
      var label = d > 0 ? d + 'd ' + h + 'h' : (h > 0 ? h + 'h ' + m + 'm' : m + 'm');
      var template = today ? node.getAttribute('data-template') : node.getAttribute('data-after');
      var safe = String(template)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      out.innerHTML = safe.replace(/\[time\]/g, '<strong class="kop11-dispatch__time">' + label + '</strong>');
    }
  }

  var cutoffTimer = null;

  /* ---------------------------------------------------------------- boot */
  function boot() {
    if (!live()) return;
    observeReveals(document);
    var kitsAll = document.querySelectorAll('[data-kop11-kits]');
    for (var i = 0; i < kitsAll.length; i++) {
      var scope = kitsAll[i].getAttribute('data-kop11-scope');
      var options = optionsFor(scope);
      if (options && !options.querySelector('.kop11-opt.is-chosen')) {
        var first = options.querySelector('.kop11-opt');
        if (first) {
          first.classList.add('is-chosen');
          first.setAttribute('aria-pressed', 'true');
        }
      }
      var chosen = options ? options.querySelector('.kop11-opt.is-chosen img') : null;
      var stackThumb = kitsAll[i].querySelector('[data-kop11-second-thumb] img');
      if (chosen && stackThumb) {
        stackThumb.src = chosen.currentSrc || chosen.src;
        stackThumb.removeAttribute('srcset');
      }
      syncPickedName(scope);
      syncTotal(scope);
    }
    tickCutoff();
    if (!cutoffTimer && document.querySelector('[data-kop11-cutoff]')) {
      cutoffTimer = setInterval(tickCutoff, 30000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // the theme rerenders product info on variant change
  document.addEventListener('variant:change', boot);
  document.documentElement.addEventListener('variant:change', boot);
  window.addEventListener('load', boot);
  // theme editor: sections render in and out while editing
  document.addEventListener('shopify:section:load', boot);
})();

/* ==========================================================================
   Kopstorm CRO Suite - kopstorm-w11.js, W87 additions (30 Aug 2026)

   Second IIFE on purpose: the modules below are new, they share nothing with
   the buy box state machine above, and keeping them separate means a fault in
   one of them cannot take the buy column down.

     1. Build the street: slot picker, live total, one multi line add to cart
     2. Lights out: pointer and keyboard drag reveal
     3. Gift note: writes a real line item property onto the theme's own form

   All three are inert until the flag class is on <html>. Every handler is
   delegated from document, because the theme rerenders product info server
   side on a variant change and any cached node would go stale.
   ========================================================================== */
(function () {
  'use strict';

  var FLAG = 'kop-w87';
  var EDIT = 'kop-w11editor';

  function live() {
    var c = document.documentElement.classList;
    return c.contains(FLAG) || c.contains(EDIT);
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  // one formatter for the whole layer, defined in the block above
  function money(cents) {
    var fn = window.KopstormW11 && window.KopstormW11.money;
    return fn ? fn(cents) : String(Math.round(cents) / 100);
  }

  /* ====================================================== build the street */

  var activeSlot = null;
  var activeStreet = null;

  function streetBase(street) {
    // the fixed first card always carries this product's own price
    var el = street.querySelector('.kop11-street__card.is-fixed .kop11-street__price');
    var raw = el ? el.getAttribute('data-cents') : null;
    return raw ? parseInt(raw, 10) : 0;
  }

  function streetPicked(street) {
    var out = [];
    var slots = street.querySelectorAll('[data-kop11-slot]');
    for (var i = 0; i < slots.length; i++) {
      var variant = slots[i].getAttribute('data-variant');
      if (variant) {
        out.push({
          variant: variant,
          price: parseInt(slots[i].getAttribute('data-price') || '0', 10)
        });
      }
    }
    return out;
  }

  function streetSync(street) {
    var picked = streetPicked(street);
    var pct = parseInt(street.getAttribute('data-kop11-pct') || '0', 10);
    var gross = streetBase(street);
    for (var i = 0; i < picked.length; i++) gross += picked[i].price;

    var slotCount = street.querySelectorAll('[data-kop11-slot]').length;
    var full = picked.length === slotCount && slotCount > 0;
    var net = full && pct > 0 ? Math.round(gross * (100 - pct) / 100) : gross;

    var totalEl = street.querySelector('[data-kop11-street-total]');
    if (totalEl) totalEl.textContent = money(net);

    var wasEl = street.querySelector('[data-kop11-street-was]');
    if (wasEl) {
      if (net < gross) {
        wasEl.textContent = money(gross);
        wasEl.removeAttribute('hidden');
      } else {
        wasEl.setAttribute('hidden', '');
      }
    }

    var saveEl = street.querySelector('[data-kop11-street-save]');
    if (saveEl) {
      if (net < gross) {
        saveEl.textContent = saveEl.getAttribute('data-prefix') || 'You save ';
        saveEl.textContent += money(gross - net);
        saveEl.removeAttribute('hidden');
      } else {
        saveEl.setAttribute('hidden', '');
      }
    }

    var cta = street.querySelector('[data-kop11-street-cta]');
    if (cta) {
      var single = cta.getAttribute('data-single');
      var multi = cta.getAttribute('data-multi');
      if (single && multi) cta.textContent = picked.length ? multi : single;
    }
  }

  function streetFill(slot, opt) {
    var media = slot.querySelector('[data-kop11-slot-media]');
    var name = slot.querySelector('[data-kop11-slot-name]');
    var price = slot.querySelector('[data-kop11-slot-price]');
    var empty = slot.querySelector('[data-kop11-slot-empty]');
    var filled = slot.querySelector('[data-kop11-slot-filled]');

    slot.setAttribute('data-variant', opt.getAttribute('data-variant'));
    slot.setAttribute('data-price', opt.getAttribute('data-price'));

    var img = opt.getAttribute('data-img');
    if (media) {
      media.innerHTML = '';
      if (img) {
        var el = document.createElement('img');
        el.src = img;
        el.alt = '';
        el.loading = 'lazy';
        media.appendChild(el);
      }
    }
    if (name) name.textContent = opt.getAttribute('data-title') || '';
    if (price) price.textContent = opt.getAttribute('data-money') || '';
    if (empty) empty.setAttribute('hidden', '');
    if (filled) filled.removeAttribute('hidden');
  }

  function streetAdd(street, button) {
    var picked = streetPicked(street);
    var form = document.querySelector('form[action*="/cart/add"]');
    var items = [];

    var base = street.querySelector('.kop11-street__card.is-fixed');
    var baseVariant = base ? base.getAttribute('data-variant') : null;
    if (baseVariant) items.push({ id: parseInt(baseVariant, 10), quantity: 1 });
    for (var i = 0; i < picked.length; i++) {
      items.push({ id: parseInt(picked[i].variant, 10), quantity: 1 });
    }
    if (!items.length) return;

    var errorBox = street.querySelector('[data-kop11-street-error]');
    if (errorBox) errorBox.setAttribute('hidden', '');

    button.classList.add('is-busy');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } })
        );
        if (form) form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () {
        // Error Feedback: say so in place, out loud, instead of a silent jump
        if (errorBox) errorBox.removeAttribute('hidden');
      })
      .then(function () {
        button.classList.remove('is-busy');
        button.setAttribute('aria-busy', 'false');
        button.disabled = false;
      });
  }

  /* ============================================================ lights out */

  function lightsSet(stage, pct) {
    var clamped = Math.max(2, Math.min(98, pct));
    stage.style.setProperty('--kop11-split', clamped + '%');
    stage.classList.add('is-touched');
    var handle = stage.querySelector('.kop11-lights__handle');
    if (handle) handle.setAttribute('aria-valuenow', Math.round(clamped));
  }

  function lightsFromEvent(stage, clientX) {
    var box = stage.getBoundingClientRect();
    if (!box.width) return;
    lightsSet(stage, ((clientX - box.left) / box.width) * 100);
  }

  function bindLights() {
    if (!live()) return;
    var stages = document.querySelectorAll('[data-kop11-reveal-slider]:not([data-kop11-bound])');
    for (var i = 0; i < stages.length; i++) {
      (function (stage) {
        stage.setAttribute('data-kop11-bound', '');
        var dragging = false;

        stage.addEventListener('pointerdown', function (event) {
          if (event.target.closest('[data-kop11-lights-set]')) return;
          dragging = true;
          if (stage.setPointerCapture) {
            try { stage.setPointerCapture(event.pointerId); } catch (e) { /* older engines */ }
          }
          lightsFromEvent(stage, event.clientX);
        });
        stage.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          lightsFromEvent(stage, event.clientX);
        });
        stage.addEventListener('pointerup', function () { dragging = false; });
        stage.addEventListener('pointercancel', function () { dragging = false; });

        var handle = stage.querySelector('.kop11-lights__handle');
        if (handle) {
          handle.addEventListener('keydown', function (event) {
            var now = parseFloat(handle.getAttribute('aria-valuenow') || '55');
            if (event.key === 'ArrowLeft') { lightsSet(stage, now - 4); event.preventDefault(); }
            if (event.key === 'ArrowRight') { lightsSet(stage, now + 4); event.preventDefault(); }
            if (event.key === 'Home') { lightsSet(stage, 4); event.preventDefault(); }
            if (event.key === 'End') { lightsSet(stage, 96); event.preventDefault(); }
          });
        }
      })(stages[i]);
    }
  }

  /* ============================================================= gift note */

  function giftForm(scope) {
    if (!scope) return null;
    return document.getElementById(scope) || document.querySelector('form[action*="/cart/add"]');
  }

  function giftWrite(box) {
    var input = box.querySelector('[data-kop11-gift-input]');
    var form = giftForm(box.getAttribute('data-kop11-scope'));
    if (!input || !form) return;

    var name = 'properties[' + (box.getAttribute('data-kop11-property') || 'Gift message') + ']';
    var hidden = form.querySelector('input[data-kop11-gift-field]');
    var value = input.value.trim();

    if (!value) {
      if (hidden && hidden.parentNode) hidden.parentNode.removeChild(hidden);
      return;
    }
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.setAttribute('data-kop11-gift-field', '');
      form.appendChild(hidden);
    }
    hidden.setAttribute('name', name);
    hidden.value = value;
  }

  /* ================================================================ events */

  document.addEventListener('click', function (event) {
    if (!live()) return;
    var target = event.target;

    var slotBtn = closest(target, '[data-kop11-slot-open]');
    if (slotBtn) {
      activeSlot = closest(slotBtn, '[data-kop11-slot]');
      activeStreet = closest(slotBtn, '[data-kop11-street]');
      return;
    }

    var opt = closest(target, '[data-kop11-street-opt]');
    if (opt && activeSlot && activeStreet) {
      event.preventDefault();
      streetFill(activeSlot, opt);
      streetSync(activeStreet);
      var closer = document.querySelector('[data-kop11-modal].is-open [data-kop11-modal-close]');
      if (closer) closer.click();
      return;
    }

    var addBtn = closest(target, '[data-kop11-street-add]');
    if (addBtn) {
      var street = closest(addBtn, '[data-kop11-street]');
      if (street) {
        event.preventDefault();
        streetAdd(street, addBtn);
      }
      return;
    }

    var lightsBtn = closest(target, '[data-kop11-lights-set]');
    if (lightsBtn) {
      var stage = closest(lightsBtn, '[data-kop11-reveal-slider]');
      if (stage) {
        event.preventDefault();
        lightsSet(stage, parseFloat(lightsBtn.getAttribute('data-kop11-lights-set')));
        var tags = stage.querySelectorAll('[data-kop11-lights-set]');
        for (var t = 0; t < tags.length; t++) {
          tags[t].setAttribute('aria-pressed', tags[t] === lightsBtn ? 'true' : 'false');
        }
      }
      return;
    }

    var giftToggle = closest(target, '[data-kop11-gift-toggle]');
    if (giftToggle) {
      var open = giftToggle.getAttribute('aria-expanded') === 'true';
      giftToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      var body = giftToggle.parentNode.querySelector('.kop11-giftnote__body');
      if (body) {
        if (open) body.setAttribute('hidden', '');
        else body.removeAttribute('hidden');
      }
    }
  });

  document.addEventListener('input', function (event) {
    if (!live()) return;
    var input = closest(event.target, '[data-kop11-gift-input]');
    if (!input) return;
    var box = closest(input, '[data-kop11-giftnote]');
    if (!box) return;
    var count = box.querySelector('[data-kop11-gift-count]');
    if (count) count.textContent = String(input.value.length);
    giftWrite(box);
  });

  function init() {
    if (!live()) return;
    bindLights();
    var streets = document.querySelectorAll('[data-kop11-street]');
    for (var i = 0; i < streets.length; i++) streetSync(streets[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
